import { __extends, __decorate, __metadata } from 'tslib';
import { Ref, Model, Prop, Watch, Component, Vue } from 'vue-property-decorator';
import __vue_component__ from '../../icons/action/delete/IconActionDelete.vue.js';
import 'reflect-metadata';
import __vue_component__$2 from '../HseIconButton/HseIconButton.vue.js';
import __vue_component__$1 from './HseModalOverlay.vue.js';

/**
 * Базовое модальное окно
 */
var HseBaseModal = /** @class */ (function (_super) {
    __extends(HseBaseModal, _super);
    function HseBaseModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = Boolean(_this.open);
        return _this;
    }
    Object.defineProperty(HseBaseModal.prototype, "closeIcon", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    HseBaseModal.prototype.close = function () {
        this.isOpen = false;
    };
    HseBaseModal.prototype.handleOpenChanged = function (v) {
        this.isOpen = !!v;
    };
    HseBaseModal.prototype.handleIsOpenChanged = function (v) {
        var _this = this;
        if (!!v !== this.open)
            this.$emit('toggle', v);
        if (v) {
            this.$nextTick(function () {
                _this.modalOverlay.$el.focus();
            });
        }
    };
    HseBaseModal.prototype.onOverlayClick = function (e) {
        var modalOverlay = this.modalOverlay;
        if (!modalOverlay || !modalOverlay.$el)
            return;
        if (e.target === modalOverlay.$el) {
            /**
             * Срабатывает при клике на оверлей
             * @type {MouseEvent}
             */
            this.$emit('click:overlay', e);
            if (this.shouldCloseOnOverlayClick)
                this.close();
        }
    };
    HseBaseModal.prototype.onEscPress = function () {
        if (this.shouldCloseOnEsc)
            this.close();
    };
    __decorate([
        Ref('modalOverlay'),
        __metadata("design:type", __vue_component__$1)
    ], HseBaseModal.prototype, "modalOverlay", void 0);
    __decorate([
        Model('toggle'),
        __metadata("design:type", Boolean)
    ], HseBaseModal.prototype, "open", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseBaseModal.prototype, "shouldCloseOnOverlayClick", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseBaseModal.prototype, "shouldCloseOnEsc", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseBaseModal.prototype, "modalClass", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseBaseModal.prototype, "modalStyle", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                wrapper: '',
                closeButton: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseBaseModal.prototype, "classes", void 0);
    __decorate([
        Watch('open'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseBaseModal.prototype, "handleOpenChanged", null);
    __decorate([
        Watch('isOpen', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseBaseModal.prototype, "handleIsOpenChanged", null);
    HseBaseModal = __decorate([
        Component({
            name: 'HseBaseModal',
            components: {
                HseIconButton: __vue_component__$2,
                HseModalOverlay: __vue_component__$1
            }
        })
    ], HseBaseModal);
    return HseBaseModal;
}(Vue));

export default HseBaseModal;
